import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const ECOMShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="ECOM Section"
    sectionKey="ECOM"
    backRoute="/sections/ecom"
  />
);

export default ECOMShipmentRequest;
